import { Stack } from '@bedrock-layout/stack';
import styled from 'styled-components';

export const ConnectorsContainer = styled(Stack)`
  border-block-start: none;
`;
